export const colors: any = {
  primary: '#263077',
  primary100: '#F3F8FF',
  primary200: '#E5E8F4',
  primary600: '#D9DCF9',
  primary300: '#E0DAFE',
  primary400: '#D5CDFF',
  secondary: '#2CB7DF',
  secondary50: '#E7F6FD',
  secondary100: '#F5F3FF',
  secondary150: '#E6F5FC',
  secondary200: '#DDE2FE',
  black: '#000',
  white: '#fff',
  white100: '#E9E9E9',
  white150: '#EBEBEB',
  text: '#414146',
  text100: '#737382',
  text200: '#686868',
  text300: '#767676',
  text500: '#333333',
  text600: '#8D93B3',
  placeholder: '#B9B9B9',
  placeholder600: '#D9D9D9',
  inputBorder: '#E9E9E9',
  danger: '#EA5455',
  danger50: '#FEECEF',
  success: '#10B981',
  green50: '#E7F8F2',
  green100: '#CCFBF1',
  green150: '#D1FAE5',
  green200: '#F0FFF5',
  green250: '#E9F9EE',
  yellow50: '#FEF5E7',
  yellow100: '#ECFCCB',
  yellow150: '#FEF9C3',
  yellow200: '#FFFCD9',
  yellow250: '#FFF0D2',
  orange100: '#FCE1B3',
  pink100: '#FFF2FD',
  pink300: '#FFE5EE',
  pink400: '#FFDEF4',
  cream300: '#FFDDBE',
  cream600: '#FFD0A4',
}

export const createTheme = () => {
  const theme = {
    colors: colors,
  }

  return theme
}

const theme = createTheme()
export default theme
